<template>
  <v-layout
    v-if="this.question"
    align-space-between
    column
    fill-height
    justify-center
  >
    <v-card
      id="create"
      :loading="this.$props.loading"
      style="min-height: calc(100vh - 185px)"
    >
      <v-container fluid pa-0>
        <v-toolbar
          color=" lighten-4"
          :class="this.$vuetify.theme.isDark ? 'black' : 'grey'"
          id="question-toolbar"
          flat
        >
          <span class="question-id">
            {{ question.identifier }}
          </span>
          <div v-if="!this.$vuetify.breakpoint.smAndDown" class="pl-2">
            <v-icon>account_balance</v-icon>
          </div>
          <div class="topic-text pl-2" style="font-size: 20px">
            {{ question.topic }}
          </div>
          <v-spacer></v-spacer>
          <div v-if="disabled">
            <v-chip v-if="question.correct" color="teal" text-color="white">
              <v-avatar>
                <v-icon>check_circle</v-icon>
              </v-avatar>
              Correto
            </v-chip>
            <v-chip v-else color="error" text-color="white">
              <v-avatar>
                <v-icon>thumb_down</v-icon>
              </v-avatar>
              Errado
            </v-chip>
          </div>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item :disabled="disabled" @click="clearAnswer()">
                <v-list-item-title>
                  <v-icon>delete</v-icon>
                  Limpar Resposta
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                :disabled="disabled || mode === 2"
                @click="$emit('checkAnswer')"
              >
                <v-list-item-title>
                  <v-icon>done</v-icon>
                  Corrigir Questão {{ question.identifier }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item :disabled="disabled" @click="$emit('pauseMock')">
                <v-list-item-title>
                  <v-icon>pause</v-icon>
                  Pausar Simulado
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('checkAnswers')">
                <v-list-item-title>
                  <v-icon>done_all</v-icon>
                  Finalizar Simulado
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
        <v-card-text class="pl-4 pr-4">
          <v-layout row wrap>
            <v-flex lg9 md9 xs12>
              <p v-html="question.statement"></p>
              <v-radio-group v-model="question.answer">
                <v-radio
                  :class="[{ correct: isCorrect(1) }]"
                  :disabled="disabled"
                  value="1"
                >
                  <template slot="label">
                    <div class="ma-2">{{ question.option_1 }}</div>
                  </template>
                </v-radio>
                <v-radio
                  :class="[{ correct: isCorrect(2) }]"
                  :disabled="disabled"
                  value="2"
                >
                  <template slot="label">
                    <div class="ma-2">{{ question.option_2 }}</div>
                  </template>
                </v-radio>
                <v-radio
                  v-if="question.option_3"
                  :class="[{ correct: isCorrect(3) }]"
                  :disabled="disabled"
                  value="3"
                >
                  <template slot="label">
                    <div class="ma-2">{{ question.option_3 }}</div>
                  </template>
                </v-radio>
                <v-radio
                  v-if="question.option_4"
                  :class="[{ correct: isCorrect(4) }]"
                  :disabled="disabled"
                  value="4"
                >
                  <template slot="label">
                    <div class="ma-2">{{ question.option_4 }}</div>
                  </template>
                </v-radio>
                <v-radio
                  v-if="question.option_5"
                  :class="[{ correct: isCorrect(5) }]"
                  :disabled="disabled"
                  value="5"
                >
                  <template slot="label">
                    <div class="ma-2">{{ question.option_5 }}</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="disabled" lg3 md3 xs12>
              <div
                style="
                  text-align: center;
                  margin-left: auto;
                  margin-right: auto;
                "
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <div
                      id="thumb"
                      v-on="on"
                      :style="{
                        backgroundImage: `url(${question.thumbnail})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                      }"
                    >
                      <div id="play-btn-wrap">
                        <a class="play-btn" @click="showVideo()">
                          <span id="play"></span>
                        </a>
                      </div>
                    </div>
                  </template>
                  <span>Assista o video de correção</span>
                </v-tooltip>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-container>
      <v-speed-dial
        v-model="fab"
        :bottom="true"
        :left="false"
        :right="true"
        :top="false"
        direction="top"
        style="z-index: 3"
      >
        <template v-slot:activator>
          <v-btn
            v-model="fab"
            color="primary"
            dark
            fab
            large
            :disabled="disabled"
          >
            <v-icon v-if="fab">close</v-icon>
            <v-icon v-else>edit</v-icon>
          </v-btn>
        </template>
        <v-tooltip v-model="showTooltip" left nudge-left="20">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="red"
              dark
              fab
              @click="clearAnswer()"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </template>
          <span>Limpar Resposta</span>
        </v-tooltip>
        <v-tooltip v-model="showTooltip" left nudge-left="20">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="disabled || mode === 1"
              v-bind="attrs"
              v-on="on"
              color="accent"
              dark
              fab
              @click="$emit('checkAnswer')"
            >
              <v-icon>done</v-icon>
            </v-btn>
          </template>
          <span>Corrigir Questão {{ question.identifier }}</span>
        </v-tooltip>
        <v-tooltip v-model="showTooltip" left nudge-left="20">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="secondary"
              dark
              fab
              @click="$emit('pauseMock')"
            >
              <v-icon>pause</v-icon>
            </v-btn>
          </template>
          <span>Pausar o simulado</span>
        </v-tooltip>
        <v-tooltip v-model="showTooltip" left nudge-left="20">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="green"
              dark
              fab
              @click="$emit('checkAnswers')"
            >
              <v-icon>done_all</v-icon>
            </v-btn>
          </template>
          <span>Finalizar simulado</span>
        </v-tooltip>
      </v-speed-dial>
    </v-card>
    <v-dialog
      v-model="dialogVideo"
      content-class="elevation-0"
      max-width="calc(85vw)"
      min-width="330px"
      overlay-opacity="0.8"
      style="margin: 0"
    >
      <div id="video-2" class="d-flex flex-column-reverse flex-sm-row">
        <div style="width: 100%">
          <iframe
            v-if="videoSource === 'panda' && reloadPanda === true"
            :id="`panda-XXXX`"
            :src="`https://player-vz-6b763bac-40b.tv.pandavideo.com.br/embed/?v=${this.videoId}&muted=false&saveProgress=false`"
            allowfullscreen="true"
            style="border: 0; width: 100%"
          >
          </iframe>

          <video-player
            v-else
            ref="vp"
            :media-source="this.mediaSource"
            :type="'question'"
            :video-id="videoId"
            @canplay="isReady = true"
            @pause="checkSubscribing"
            @play="isReady = true"
            @stop="checkSubscribing"
            @timeupdate="onTimeUpdate"
          />
        </div>
        <v-btn
          :x-small="$vuetify.breakpoint.xsOnly"
          small
          class="ml-2 mb-2 d-flex align-self-end align-self-sm-start"
          dark
          fab
          icon
          outlined
          @click="closePlayer"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-dialog>
  </v-layout>
</template>
<style scoped>
#panda-XXXX {
  height: 85vh;
}
@media (max-width: 600px) {
  #panda-XXXX {
    height: 400px;
  }
}
</style>
<script>
import QuestionService from "../../services/questions.service";
import VideoPlayer from "@/components/VideoPlayer";

export default {
  data() {
    return {
      mediaSource: null,
      awnser: null,
      dialogVideo: false,
      reloadPanda: true,
      fullQuestion: null,
      courses: [],
      topics: [],
      subjects: [],
      stopTime: Math.random() * (25 - 5) + 5,
      videoId: null,
      videoSource: "panda",
      isReady: false,
      fab: false,
      showTooltip: true,
      pandaLoaded: false,
    };
  },
  computed: {
    player() {
      return this.$refs.vp.$refs.plyr.player;
    },
  },
  components: {
    VideoPlayer,
  },
  props: {
    question: Object,
    disabled: Boolean,
    mode: Number,
    loading: false,
  },
  mounted() {},
  created() {},
  watch: {
    // sempre que a pergunta mudar, essa função será executada
    dialogVideo: function (newValue, oldValue) {
      if (!newValue) {
        this.videoSource === "panda" ? this.pausePanda() : this.unloadVimeo();
      } else {
        this.videoSource === "panda" ? this.pausePanda() : null;
      }
    },
  },
  methods: {
    pauseMock() {
      this.$emit("clicked", "someValue");
      this.$emit("pauseMock");
    },
    closePlayer() {
      this.videoSource === "panda" ? this.unloadPanda() : this.unloadVimeo();
      this.dialogVideo = false;
      this.isReady = false;
    },
    clearAnswer() {
      this.question.answer = null;
    },
    isCorrect(option) {
      if (this.disabled && this.question.correct_answer) {
        return this.question.correct_answer == option;
      }
    },
    showVideo() {
      this.loading = true;
      QuestionService.getById(this.question.id, { include: "video" })
        .then((resp) => {
          this.fullQuestion = resp.data;
          this.question.video = resp.data.video;
          this.setVideos(this.fullQuestion.video);
          this.loading = false;
          this.dialogVideo = true;
          this.videoId = resp.data.video.identifier;
          this.reloadPanda = true;
          this.videoSource = resp.data.video.source;
          if (this.videoSource === "vimeo") {
            this.pandaLoaded = false;
          }
          this.$forceUpdate();
        })
        .then(() => {
          if (this.videoSource === "panda" && this.pandaLoaded === false) {
            window.pandascripttag = window.pandascripttag || [];
            window.pandascripttag.push(() => {
              const player = new PandaPlayer("panda-XXXX", {
                onReady: () => {
                  this.pandaLoaded = true;
                  player.onEvent(({ message, ...rest }) => {
                    if (message === "panda_timeupdate") {
                      try {
                        this.onTimeUpdate({ seconds: rest.currentTime });
                      } catch (error) {
                        console.log(error, "erro no timeupdate");
                      }
                    }
                    if (
                      message === "panda_pause" ||
                      message === "panda_ended"
                    ) {
                      this.checkSubscribing();
                    }
                    if (
                      message === "panda_canplay" ||
                      message === "panda_play"
                    ) {
                      this.isReady = true;
                    }
                  });
                },
                onError: (event) => {
                  console.log("Player onError", event);
                },
              });
            });
          }
        })
        .catch((err) => {
          //window.getApp.sendSnackMessage(err.message)
          console.log(err);
          this.loading = false;
        });
    },
    setVideos(video) {
      if (video == null) return;
      let srcs = [];
      // console.log(video.media_hd_url)
      if (video.media_hd_url) {
        srcs.push({
          src: video.media_hd_url,
          type: "video/mp4",
          size: 720,
        });
      }
      if (video.media_sd_url) {
        srcs.push({
          src: video.media_sd_url,
          type: "video/mp4",
          size: 480,
        });
      }
      if (video.media_mobile_url) {
        srcs.push({
          src: video.mobile_url,
          type: "video/mp4",
          size: 360,
        });
      }
      this.mediaSource = {
        type: "video",
        title: video.video,
        poster: video.big_thumbnail,
        sources: srcs,
      };
      // console.log(this.source.sources)
    },
    onTimeUpdate(e) {
      //      console.log('testando aluno', this.question.subscriber)
      let currentTime = e.seconds
        ? e.seconds
        : e.target
          ? e.target.currentTime
          : 0;
      if (!this.fullQuestion.subscriber && currentTime > this.stopTime) {
        this.cancelVideoPlay();
      }
    },
    checkSubscribing() {
      if (!this.fullQuestion.subscriber) this.cancelVideoPlay();
    },
    unloadVimeo() {
      this.player.setCurrentTime(0);
      this.player.pause();
    },
    async unloadPanda() {
      const iframe = document.getElementById("panda-XXXX").contentWindow;
      this.reloadPanda = false;
      await iframe.postMessage({ type: "pause" }, "*");
      await iframe.postMessage({ type: "currentTime", parameter: 0 }, "*");
    },
    pausePanda() {
      const iframe = document.getElementById("panda-XXXX").contentWindow;

      iframe.postMessage({ type: "pause" }, "*");
    },
    cancelVideoPlay() {
      if (this.isReady) {
        this.videoSource ? this.unloadPanda() : this.unloadVimeo();
        this.dialogVideo = false;
        window.getApp.sendSnackMessage("Conteúdo exclusivo para alunos 🤷‍♂");
        this.isReady = false;
      }
    },
  },
};
</script>

<style>
@media screen and (max-width: 600px) {
  #question-toolbar .v-toolbar__title {
    flex-basis: 120px;
  }
  #question-toolbar .v-toolbar__content {
    padding-left: 8px;
    padding-right: 8px;
  }
}
.question-id {
  background-color: #cfd8dc;
  padding: 2px 15px;
  border-radius: 9999px;
}
img {
  max-width: 100%;
  height: auto;
}

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}

.topic-text {
  overflow: hidden;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.correct {
  border-style: dotted;
  color: green;
  border-color: green;
  padding: 5px;
}

p {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 20px;
  font-weight: 300;
  letter-spacing: normal;
}

.video {
  max-height: calc(100vh - 200px);
  box-shadow: none;
}

#play-btn-wrap {
  margin: 0 auto;
  padding-top: 20%;
  padding-bottom: 20%;
  display: block;
  position: relative;
  text-align: center;
  background-repeat: no-repeat;
}

.play-btn {
  background-image: url(/img/player/play-rounded-button-1.svg);
  display: inline-block;
  width: 25%;
  height: 15vh;
  position: relative;
  text-align: center;
  background-size: contain;
}

.play-btn.hover {
  border-color: rgba(255, 255, 255, 1);
}
</style>
